import TopicFilterHelpers from '../classes/TopicFilterHelpers'
import * as TLM from '../constants/tlm'
import moment from 'moment'
import { BRAND_PREFERENCE, DEMOGRAPHICS } from '../constants/commons'

const ANTICIPATION_VIDEO_REGEX = ['\\b(?i)(trailer|teaser|promo|sizzle|sneak\\speak)(?<!Channel\\sTrailer)\\b']

/* Collection of helpers for dealing with Topic Plan Filters */
class TopicPlanFilterHelpers {
  tlmFilter (menu, key) {
    if (menu === 'Network') {
      return {
        subType: [TLM.SHOW, TLM.MOVIE],
        label: ['Linear'],
        defaultAction: TLM.OR
      }
    } else if (menu === 'Online Video') {
      return {
        subType: [TLM.CHANNEL],
        defaultAction: TLM.OR
      }
    } else if (menu === 'Shows' || menu === 'Movies' || menu === 'Person' || menu === 'People' || menu === 'Brands' || menu === TLM.MUSIC || menu === TLM.BRAND || menu === TLM.CHANNEL || (key === TLM.TLM_VPP && menu === TLM.GAMING)) {
      let sub_type = menu
      if (sub_type === 'Shows') {
        sub_type = TLM.SHOW
      } else if (sub_type === 'Movies') {
        sub_type = TLM.MOVIE
      } else if (sub_type === 'Person') {
        sub_type = 'People'
      } else if (sub_type === 'Brands') {
        sub_type = TLM.BRAND
      }
      return {
        subType: [sub_type],
        defaultAction: TLM.OR
      }
    } else if (menu === 'Streaming') {
      return {
        subType: [TLM.SHOW, TLM.MOVIE],
        label: ['Streaming'],
        defaultAction: TLM.OR
      }
    } else {
      return TopicFilterHelpers.getFilter(menu, key)
    }
  }

  programmingFilter (menu) {
    if (menu === 'Primetime') {
      return {
        subType: [TLM.SHOW],
        label: ['Primetime'],
        defaultAction: TLM.OR
      }
    } else if (menu === 'Broadcast') {
      return {
        subType: [TLM.SHOW],
        label: ['Broadcast'],
        defaultAction: TLM.OR
      }
    } else if (menu === 'Cable') {
      return {
        subType: [TLM.SHOW],
        label: ['Cable'],
        defaultAction: TLM.OR
      }
    } else if (menu === 'Premium') {
      return {
        subType: [TLM.SHOW],
        label: ['Premium'],
        defaultAction: TLM.OR
      }
    } else if (menu === 'BroadcastPrimetime') {
      return {
        subType: [TLM.SHOW],
        label: ['Broadcast', 'Primetime'],
        defaultAction: TLM.AND
      }
    } else if (menu === 'RemoveNetworkContent') {
      return {
        subType: [TLM.CHANNEL],
        label: ['Network Content'],
        defaultAction: TLM.NOT
      }
    } else if (menu === 'RemoveCancelled') {
      return {
        subType: [TLM.SHOW],
        label: ['Cancelled'],
        defaultAction: TLM.NOT
      }
    } else if (menu === 'RemoveSpecial') {
      return {
        subType: [TLM.SHOW],
        label: ['Special'],
        defaultAction: TLM.NOT
      }
    } else if (menu === 'RemoveBottomQuintile') {
      return {
        subType: [TLM.SHOW, TLM.MOVIE],
        threshold: 0.8,
        defaultAction: TLM.OR
      }
    }
  }

  genreFilter (menu) {
    return {
      subType: [TLM.SHOW, TLM.MOVIE],
      label: [menu],
      defaultAction: TLM.OR
    }
  }

  otherFilter (menu, module, filters) {
    if (menu === 'Anticipation') {
      return {
        subType: [TLM.MOVIE, TLM.SHOW, TLM.VIDEO],
        topic_name_match: ANTICIPATION_VIDEO_REGEX,
        date_range: new FilterDateRange({
          start_date: moment(new Date()).format('YYYY-MM-DD')
        }),
        defaultAction: TLM.OR
      }
    } else if (menu === 'RemoveBottomQuintile') {
      switch (module) {
        case BRAND_PREFERENCE:
          return {
            subType: [TLM.BRAND],
            threshold: 0.8
          }
        case DEMOGRAPHICS:
          return {
            subType: [TLM.LIFESTYLE],
            threshold: 0.8
          }
        default:
          const types = filters && filters._filters.length > 0 ? filters._filters.map(f => f.topic_sub_type) : []
          return {
            subType: types,
            threshold: 0.8,
            defaultAction: TLM.OR
          }
      }
    } else if (menu === 'ActiveContent') {
      return [
        {
          subType: [TLM.MOVIE],
          date_range: new FilterDateRange({
            start_date: moment().subtract(2, 'years').format('YYYY-MM-DD')
          }),
          defaultAction: TLM.AND
        },
        {
          subType: [TLM.SHOW, TLM.MOVIE],
          label: ['Cancelled'],
          date_range: new FilterDateRange({
            start_date: moment().subtract(2, 'years').format('YYYY-MM-DD')
          }),
          defaultAction: TLM.NOT
        },
        {
          subType: [TLM.SHOW, TLM.MOVIE],
          label: 'Sports',
          date_range: new FilterDateRange({
            start_date: moment().subtract(2, 'years').format('YYYY-MM-DD')
          }),
          defaultAction: TLM.AND
        },
        {
          subType: [TLM.SHOW, TLM.MOVIE],
          label: 'Specials',
          date_range: new FilterDateRange({
            start_date: moment().subtract(1, 'years').format('YYYY-MM-DD')
          }),
          defaultAction: TLM.AND
        }
      ]
    }
  }

  mediaTypeFilter (type) {
    return {
      subType: [type],
      defaultAction: TLM.OR
    }
  }
}

class FilterDateRange {
  constructor (args = {}) {
    this.start_date = this._wrap(args.start_date)
    this.end_date = this._wrap(args.end_date)
  }

  _wrap (arg) {
    if (arg) {
      if (typeof arg === 'string' || arg instanceof String) {
        return arg
      } else {
        return undefined
      }
    }
    return arg
  }
}

const instance = new TopicPlanFilterHelpers()

export default instance
